var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-table',{attrs:{"total":Object.keys(_vm.data).length,"columns":_vm.columnsFormatted,"data":_vm.dataFormatted},scopedSlots:_vm._u([{key:"actions",fn:function(ref){
var row = ref.row;
return _c('div',{})}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }